import { WeekDay } from "shared/types";
import {createArray} from "utils"

export const PAGE_SIZE = 10;
export const BRANDING_IMAGE_URL = "/api/super/clientDetails/readBrandingImage";
export const SUB_CLIENT_BRANDING_IMAGE_URL =
  "/api/super/subClientDetails/readBrandingImage";
export const LOGO_URL = "/auth/readBrandingImage?key=";
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
export const IMAGE_HEIGHT = 500;
export const IMAGE_WIDTH = 500;
export const BRANDING_IMAGE_WIDTH = 500;
export const BRANDING_IMAGE_HEIGHT = 500;
export const BRANDING_LOGIN_IMAGE_HEIGHT = 400;
export const BRANDING_LOGIN_IMAGE_WIDTH = 540;
export const IMAGE_SIZE = 2;
export const DOCUMENT_SIZE = 5;
export const OTP_CODE_EXPIRE_IN = "15:00";
export const FREQUENCY = ["Daily", "Weekly", "Monthly"];
export const WeekDaysList = [
  { label: "Sunday", value: "1" },
  { label: "Monday", value: "2" },
  { label: "Tuesday", value: "3" },
  { label: "Wednesday", value: "4" },
  { label: "Thursday", value: "5" },
  { label: "Friday", value: "6" },
  { label: "Saturday", value: "7" },
];

export const MonthDaysList = [
  { label: "January", value: "Jan" },
  { label: "Feburary", value: "Feb" },
  { label: "March", value: "Mar" },
  { label: "April", value: "Apr" },
  { label: "May", value: "May" },
  { label: "June", value: "Jun" },
  { label: "July", value: "Jul" },
  { label: "August", value: "Aug" },
  { label: "September", value: "Sep" },
  { label: "October", value: "Oct" },
  { label: "November", value: "Nov" },
  { label: "December", value: "Dec" },
];

export const MONTHS_GROUP = ["12", "24", "36", "48", "60", "72", "84"];

export const IMAGE_TYPES = "PNG/JPEG/JPG/GIF";

export const userNameRegex = /^[A-Za-z0-9][0-9a-zA-Z.@_-]*$/;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,20}$/;
export const ipRegex =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const ipRegexWithPort =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?):([0-9]{1,5})$/;
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const zipCodeRegex = /^[A-Z0-9][A-Z0-9 -]{4,9}$/;
export const urlRegex =
  /^(http|https)?:\/\/([\w-]+\.)+[\w-]+[.com|.in|.org]+(\[\?%&=]*)?/;

export const subClientNameRegex = /^[A-Za-z][0-9A-Za-z-/ ]*$/;

export const phoneNumberRegex = /^((\(\d{3}\)))[\s{1}]\d{3}-\d{4}$/;

export const parcelNumberRegex = /^[X][X-]*$/;
export const documentNumberRegex = /^[0-9a-zA-Z]{2,15}$/;
export const floatNumberRegex = /^\.?[0-9]+\.?[0-9]*$/;
export const isNumberRegex = /^[0-9]+$/;
export const numberRegex = /[^0-9]/g;
export const alphaNumericRegex = /^[a-zA-Z0-9]+$/;

export const rateAmountRegex = /^-?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)$/;

// export enum ROLE {
//   Admin = "admin",
//   Client = "client",
//   SubClient= 'subClient',
// }
export const ROLE = {
  admin: "admin",
  client: "client",
  subClient: "subClient",
} as const;

export const systemMastersOptionsOld = [
  { label: "Distribution Type", value: "DISTRIBUTION_TYPE" },
  { label: "Jurisdiction", value: "JURISDICTION_TYPE" },
  { label: "Material Type", value: "MATERIAL_TYPE" },
  { label: "Service Type", value: "SERVICE_TYPE" },
  { label: "Commodity Type", value: "COMMODITY" },
  { label: "Size/Model", value: "SIZE" },
  { label: "Rate Detail Description", value: "RATE_DETAIL_DESCRIPTION" },
];

export const systemMastersOptions = [
  { label: "Tax/Fee Type", value: "TAX_OR_FEE_TYPE" },
  { label: "Material Type", value: "MATERIAL_TYPE" },
  { label: "Commodity Type", value: "COMMODITY" },
  { label: "Vehicle Type", value: "VEHICLE_TYPE" },
  { label: "Container Type", value: "CONTAINER_TYPE" },
  { label: "Container Type Option", value: "CONTAINER_TYPE_OPTIONS" },
  { label: "Container Size/Model", value: "SIZE" },
  { label: "Service Type", value: "SERVICE_TYPE" },
  { label: "Distribution Type", value: "DISTRIBUTION_TYPE" },
  { label: "Rate Detail Description", value: "RATE_DETAIL_DESCRIPTION" },
  { label: "Jurisdiction", value: "JURISDICTION_TYPE" },
  { label: "Rate Type", value: "RATE_TYPE" },
];

export const specialServiceOptions = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
  { label: "Ask", value: "ASK" },
];

export const salestaxOptions = [{ label: "N/A", value: null }];

export const yesNoOptions = [
  { label: "Yes", value: "YES" },
  { label: "No", value: "NO" },
];

export const addServiceTypeRoutingOptions = [
  { label: "Dynamic Routing (One-Time)", value: "NO" },
  { label: "Static Routing (Recurring)", value: "YES" },
];

export const avgWeightUnits = [
  { label: "Tons", value: "Tons" },
  { label: "Pounds", value: "Pounds" },
];
export const avgVolumeUnits = [
  { label: "Yards", value: "Yards" },
  { label: "Gallons", value: "Gallons" },
];

export const systemMasterConfigurationOptions = [
  { label: "Create their own masters", value: true },
  { label: "Copy client masters", value: false },
];

export const validationAndAutoPopulationOptions = [
  { label: "USPS", value: "USPS" },
  { label: "Google", value: "GOOGLE" },
];

export const yesNoOptionsWithTrueFalseValues = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const dropDownwithTrueFalseValues = [
  { label: "No", value: false },
  { label: "Yes", value: true },
];

export const BILLING_CYCLE = {
  // "Not Billable": {
  //   billingCycle: 1,
  //   labelDisplayName: "Not Billable"
  // },
  "Weekly (1 Week)": {
    billingCycle: 1,
    labelDisplayName: "Weekly",
  },
  "Bi-Weekly (2 Weeks)": {
    billingCycle: 1,
    labelDisplayName: "Bi-Weekly",
  },
  "Semi-Monthly (Twice a Month)": {
    billingCycle: 1,
    labelDisplayName: "Semi-Monthly",
  },
  "28 Days (4 Weeks)": {
    billingCycle: 1,
    labelDisplayName: "28 Days",
  },
  "Monthly (1 Month)": {
    billingCycle: 1,
    labelDisplayName: "Monthly",
  },
  "Bi-Monthly (2 Months)": {
    billingCycle: 2,
    labelDisplayName: "Monthly",
  },
  "Quarterly (3 Months)": {
    billingCycle: 3,
    labelDisplayName: "Monthly",
  },
  "4 Months": {
    billingCycle: 4,
    labelDisplayName: "Monthly",
  },
  "Semi-Annual (6 Months)": {
    billingCycle: 6,
    labelDisplayName: "Monthly",
  },
  "Annual (Once a Year)": {
    billingCycle: 12,
    labelDisplayName: "Monthly",
  },
};

export const passwordExpirationDaysList = [
  { label: "30", value: 30 },
  { label: "60", value: 60 },
  { label: "90", value: 90 },
];

export const sessionExpirationMinutesList = [
  { label: "15", value: 15 },
  { label: "30", value: 30 },
  { label: "45", value: 45 },
  { label: "60", value: 60 },
];

export const weekDaysLabelList = [
  { label: "Sunday", value: "Sunday" },
  { label: "Monday", value: "Monday" },
  { label: "Tuesday", value: "Tuesday" },
  { label: "Wednesday", value: "Wednesday" },
  { label: "Thursday", value: "Thursday" },
  { label: "Friday", value: "Friday" },
  { label: "Saturday", value: "Saturday" },
];

export const PAYMENT_ACTION = {
  VOID: "void",
  REVERSE: "void-reverse",
  SUPPRESS: "suppress",
} as const;

export type PaymentAction =
  (typeof PAYMENT_ACTION)[keyof typeof PAYMENT_ACTION];

export type ReadingStatus = "Billed" | "Not Billed" | "Overridden";

export const dropDownOnOffValues = [
  { label: "Off", value: false },
  { label: "On", value: true },
];

export const SSO_REDIRECT =
  "/api/subClient/customer/dashboard/arTransaction/sso/redirect";
export const SSO_ONLINE_PAYMENT =
  "/api/subClient/arTransaction/sso/onlinePayment";

export const SSO_WEIGH_MASTER_ONLINE_PAYMENT =
  "/api/subClient/weighMaster/arTransaction/sso/onlinePayment";

export const SSO_SPECIAL_SERVICE_TICKET_ONLINE_PAYMENT =
  "/api/subClient/specialServiceTicket/arTransaction/sso/onlinePayment";

export const SAVE_SPM_COMMAND = "SAVESPM";
export const MAKE_PAYMENT_COMMAND = "MAKEPAYMENT";
export const EDIT_SPM_COMMAND = "MANAGESPM";
export const MANAGE_AUTO_PAY_COMMAND = "MANAGEAUTOPAY";

export const serviceDays: { label: string; value: WeekDay }[] = [
  { label: "Sunday", value: "SUNDAY" },
  { label: "Monday", value: "MONDAY" },
  { label: "Tuesday", value: "TUESDAY" },
  { label: "Wednesday", value: "WEDNESDAY" },
  { label: "Thursday", value: "THURSDAY" },
  { label: "Friday", value: "FRIDAY" },
  { label: "Saturday", value: "SATURDAY" },
];

export const ACTIONS_CONFIG = {
  NEW_OPEN: [
    {
      label: "Print",
      value: "PRINTED",
      permissionKey: "havePermissionToPrintTicket",
    },
    {
      label: "Delete",
      value: "DELETED",
      permissionKey: "havePermissionToDeleteTicket",
    },
  ],
  PRINTED: [
    {
      label: "Void",
      value: "VOIDED",
      permissionKey: "havePermissionToVoidTicket",
    },
    {
      label: "Quick-Close",
      value: "CLOSED",
      permissionKey: "havePermissionToCloseTicket",
    },
  ],
  VOIDED: [],
};


export const daysList = [...createArray(28),{ label:"Last Day of Month", value:"L"}];
